<div class="inner-page-sidenav">
    <nav class="navbar navbar-expand-lg pb-2 py-lg-0" aria-label="Offcanvas navbar large">
        <button class="navbar-toggler sidemenu-toggler screen-reader" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasSidebar"
            aria-controls="offcanvasSidebar">
            <i class="bi bi-layout-text-sidebar"></i>
            Side Menu
        </button>
        <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasSidebar"
            aria-labelledby="offcanvasSidebarLabel">
            <div class="offcanvas-header">
                <h5 class="offcanvas-title screen-reader" id="offcanvasSidebarLabel">Side Menu</h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas"
                    aria-label="Close"></button>
            </div>
            <div class="offcanvas-body">
                <ul class="navbar-nav">

                    <li class="nav-item" *ngFor="let lnkLoop of allLinks">

                        <!-- For External Page-->
                        <a *ngIf='lnkLoop.INTLINKTYPE ==1' class="screen-reader"
                            [ngClass]="current_menu.intId == lnkLoop.intId ? 'nav-link active font-adjust' : 'nav-link font-adjust'"
                            (click)='goToExtLink(lnkLoop.VCHEXTERNALLINK,lnkLoop)' target="_blank">
                            {{htmldecode(language=='English'?lnkLoop.VCHMENUNAME:lnkLoop.VCHMENUNAMEHINDI)}}
                        </a> 
                        <!-- End  of External Page-->
                        <!-- For Plugin Page-->
                        <a *ngIf='lnkLoop.INTLINKTYPE ==2' class="screen-reader"
                            [ngClass]="current_menu.intId == lnkLoop.intId ? 'nav-link active font-adjust' : 'nav-link font-adjust'"
                            (click)="goToPluginPage(lnkLoop.INTPLUGIN,{'plugin_id':lnkLoop.intId,'selectPlugin':lnkLoop.INTPLUGIN})">
                            {{htmldecode(language=='English'?lnkLoop.VCHMENUNAME:lnkLoop.VCHMENUNAMEHINDI)}}
                        </a>
                        <!-- End  of Plugin Page-->

                        <!-- For Content Page-->
                        <a *ngIf='lnkLoop.INTLINKTYPE ==3' class="screen-reader"
                            [ngClass]="current_menu.intId == lnkLoop.intId ? 'nav-link active font-adjust' : 'nav-link font-adjust'"
                            (click)="setSelectedData(lnkLoop)" target="_blank">
                            {{htmldecode(language=='English'?lnkLoop.VCHMENUNAME:lnkLoop.VCHMENUNAMEHINDI)}}
                        </a>
                        <!-- End  of Content Page-->

                        <!-- Start of NA Menu-->
                        <a *ngIf='lnkLoop.INTLINKTYPE ==4' class="screen-reader"
                            [ngClass]="current_menu.intId == lnkLoop.intId ? 'nav-link active font-adjust' : 'nav-link sub-nav-link font-adjust'" href="javascript:void(0)">
                        <!-- for dropdown -->
                        <li class="nav-item dropdown sub-dropdown" routerLinkActive="active">
                            <a class="screen-reader" [ngClass]="checkCurrentSecondary(lnkLoop.intId) ? 'nav-link dropdown-indicator active-li font-adjust' : 'nav-link dropdown-indicator font-adjust'" href="#dpmenu{{ lnkLoop.intId }}" role="button"
                                data-bs-toggle="collapse" aria-expanded="false" aria-controls="manage-nav">
                                <span>{{htmldecode(language=='English'?lnkLoop.VCHMENUNAME:lnkLoop.VCHMENUNAMEHINDI)}}</span>
                            </a>
                            
                            <ul [ngClass]="checkCurrentSecondary(lnkLoop.intId) ? 'sub-menu nav collapse show' : 'sub-menu nav collapse'" id="dpmenu{{ lnkLoop.intId }}">
                                <li class="nav-item dropdown-item" *ngFor="let tmenu of gettertiary(lnkLoop.intId)">
                                 
                                        <!-- For External Page-->
                                            <a *ngIf='tmenu.INTLINKTYPE ==1' class="screen-reader"
                                            [ngClass]="current_menu.intId == tmenu.intId ? 'nav-link route-link active-li-child font-adjust' : 'nav-link route-link font-adjust'"
                                            (click)='goToExtLink(tmenu.VCHEXTERNALLINK,tmenu)' target="_blank">
                                            {{htmldecode(language=='English'?tmenu.VCHMENUNAME:tmenu.VCHMENUNAMEHINDI)}}
                                        </a>
                                        <!-- End  of External Page-->
                                        <!-- For Plugin Page-->
                                        <a *ngIf='tmenu.INTLINKTYPE ==2' class="screen-reader"
                                            [ngClass]="current_menu.intId == tmenu.intId ? 'nav-link route-link active-li-child font-adjust' : 'nav-link route-link font-adjust'"
                                            (click)="goToPluginPage(tmenu.INTPLUGIN,{'plugin_id':tmenu.intId,'selectPlugin':tmenu.INTPLUGIN})">
                                            {{htmldecode(language=='English'?tmenu.VCHMENUNAME:tmenu.VCHMENUNAMEHINDI)}}
                                        </a> 
                                        <!-- End  of Plugin Page-->

                                        <!-- For Content Page-->
                                        <a *ngIf='tmenu.INTLINKTYPE ==3' class="screen-reader"
                                            [ngClass]="current_menu.intId == tmenu.intId ? 'nav-link route-link active-li-child font-adjust' : 'nav-link route-link font-adjust'"
                                            (click)="setSelectedData(tmenu)" target="_blank">
                                            {{htmldecode(language=='English'?tmenu.VCHMENUNAME:tmenu.VCHMENUNAMEHINDI)}}
                                        </a>
                                        <!-- End  of Content Page-->

                                </li>
                            </ul>
                        </li>
                        <!-- for dropdown -->
                       </a>
                       <!-- End of NA Menu-->

                    </li>
 
                     <!-- for dropdown -->
                     <!-- <li class="nav-item dropdown has-megamenu">
                        <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                            Dummy asasasas asas asas asas Menu
                        </a>
                        <div class="dropdown-menu megamenu screen-reader" role="menu">
                            <div class="row justify-content-start g-3">
                                <div class="col-12 mt-0">
                                    <div class="col-megamenu">
                                        <ul class="list-unstyled">
                                            <li>
                                                <a class="screen-reader" href="javascript:void(0);">
                                                    <p class="title">
                                                        Home asas asas asas asas asas
                                                    </p>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li> -->
                    <!-- for dropdown -->

                </ul>
            </div>
        </div>
    </nav>
</div>